const SET_RECHARGE = (state, recharge) => {
  state.recharge = recharge
}

const SET_RECHARGE_PROPERTY = (state, recharge) => {
  Object.assign(state.recharge, recharge)
}

const SET_RECHARGE_WELCOME_OFFER = (state, rechargeWelcomeOffer) => {
  state.rechargeWelcomeOffer = rechargeWelcomeOffer
}

const SET_RECHARGE_WELCOME_OFFER_PROPERTY = (state, rechargeWelcomeOffer) => {
  Object.assign(state.rechargeWelcomeOffer, rechargeWelcomeOffer)
}

export default {
  SET_RECHARGE,
  SET_RECHARGE_PROPERTY,
  SET_RECHARGE_WELCOME_OFFER,
  SET_RECHARGE_WELCOME_OFFER_PROPERTY
}



// WEBPACK FOOTER //
// ./src/store/modules/recharge/mutations.js